export default "__VITE_PUBLIC_ASSET__52784971__"